import { render, staticRenderFns } from "./_Footer.vue?vue&type=template&id=50b364aa&scoped=true&"
import script from "./_Footer.vue?vue&type=script&lang=js&"
export * from "./_Footer.vue?vue&type=script&lang=js&"
import style0 from "./_Footer.vue?vue&type=style&index=0&id=50b364aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b364aa",
  null
  
)

export default component.exports